// extracted by mini-css-extract-plugin
module.exports = {"noPromotionNo":"crm-c_noPromotionNo__2ke7B","loading":"crm-c_loading__3ZAvR"};